"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InfoIcon = InfoIcon;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _react2 = _interopRequireDefault(require("@tippyjs/react"));

require("./InfoIcon.styles.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var styles = function styles(theme) {
  return {
    icon: {
      color: theme.palette.secondary.main,
      fontSize: '22px',
      cursor: 'pointer'
    }
  };
};

function InfoIcon(_ref) {
  var message = _ref.message,
      tippyProps = _ref.tippyProps,
      classes = _ref.classes;
  return /*#__PURE__*/_react["default"].createElement(_react2["default"], _extends({
    content: message,
    animation: "scale",
    theme: "my529",
    delay: [200, 0]
  }, tippyProps), /*#__PURE__*/_react["default"].createElement(_material.Icon, {
    className: classes.icon
  }, "info_outline"));
}

InfoIcon.propTypes = {
  message: _propTypes["default"].node.isRequired,
  tippyProps: _propTypes["default"].object,
  classes: _propTypes["default"].object.isRequired
};

var _default = (0, _styles.withStyles)(styles)(InfoIcon);

exports["default"] = _default;